import React, { Component } from "react";
import { connect } from "react-redux";
import Paper from "@mui/material/Paper";
import CanvasJSReact from "@canvasjs/react-charts";

import {
  dashboardActions,
  mappingActions,
  SliderProMsgActions
} from "../actions";
import tableRequest from "../models/tableRequest.js";
import Tooltip2, { tooltipClasses } from "@mui/material/Tooltip";
import "./Sidebar.css";
import "@devexpress/dx-react-chart-bootstrap4/dist/dx-react-chart-bootstrap4.css";
import { Card, CardContent, Typography } from "@mui/material";
import { Tooltip as MTooltip } from "@mui/material";
import { dashboardDetailActions } from "../actions/dashboardDetailActions.js";
import { ThreeDot } from "react-loading-indicators";
import Restricted from "../components/restricted/Restricted.js";
import { dashboardImageActions } from "../actions/dashboardImageActions.js";

const compareTargets = (
  { series, point },
  { series: targetSeries, point: targetPoint }
) => series === targetSeries && point === targetPoint;
const CanvasJSChart = CanvasJSReact.CanvasJSChart;

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.tblResponse = new tableRequest();
    this.onPage = this.onPage.bind(this);
    this.onSort = this.onSort.bind(this);
    this.state = {
      hover: null,
      globalFilter: null,
      first: 0,
      selection: [
        { ShortMonthName: "Jan", MonthName: "January", OrderCount: 0 }
      ],
      rows: 5,
      totalRecords: 0,
      sortOrder: "",
      loading: false,
      UserType: 0,
      DealerId: 0,
      tooltipTarget: null,
      tooltipEnabled: true,
      selectedWarehouse: "",
      fromDate: "",
      toDate: "",
      activeFilter: ""
    };
    this.click = ({ targets }) => {
      const target = targets[0];
      if (target) {
        this.setState(({ selection }) => ({
          selection:
            selection[0] && compareTargets(selection[0], target) ? [] : [target]
        }));
      }
    };
    this.changeHover = (hover) => this.setState({ hover });
    this.changeTooltip = (targetItem) =>
      this.setState({ tooltipTarget: targetItem });
    this.basicData = {
      labels: ["January", "February", "March", "April", "May", "June", "July"],
      datasets: [
        {
          label: "Pending",
          data: [65, 59, 80, 81, 56, 55, 40],
          fill: false,
          borderColor: "#42A5F5"
        },
        {
          label: "Active",
          data: [28, 48, 40, 19, 86, 27, 90],
          fill: false,
          borderColor: "#FFA726"
        }
      ]
    };
  }

  componentDidMount() {
    const userPages = sessionStorage.getItem("assignedPermissionsForUser");
    if (userPages) {
      const assignedPermissions = JSON.parse(userPages);
      const Curenturl = window.location.pathname;
      const nNumber = Curenturl.lastIndexOf("/");
      const pageName = Curenturl.substring(nNumber + 1);

      const obj = assignedPermissions.assigned.filter((x) => {
        return x.ActionName === pageName;
      });

      if (obj !== null && obj.length > 0) {
        if (!obj[0].IsEdit) {
          this.setState({
            IsEdit: false
          });
        }
        if (!obj[0].IsAdd) {
          this.setState({
            IsAdd: false
          });
        }
      }
    }
    this.props.fetchApi(this.tblResponse);
    const today = new Date().toISOString().split("T")[0];
    const { fromDate } = this.state;
    const roleName = sessionStorage.getItem("UserRole");
    this.props.fetchDetailApi({
      fromDate: fromDate || "2020-01-01",
      toDate: today,
      roleName: roleName
    });
    this.props.fetchMappingApi(this.tblResponse);
    this.props.fetchImageApi();
    const userDetails = sessionStorage.getItem("user");
    const DealerId = sessionStorage.getItem("UserData");

    const userdetailsObject = JSON.parse(userDetails);
    this.setState({
      UserType: userdetailsObject.UserType,
      DealerId: DealerId
    });

    const warehouseNames = this.getWarehouseNames();
    if (warehouseNames.length > 0) {
      this.setState({ selectedWarehouse: warehouseNames[0] });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.MappingData) {
      if (prevProps.MappingData !== this.props.MappingData) {
        // this.props.myProp has a different value
        if (this.props.MappingData) {
          var e = this.props.MappingData;
          this.setState({
            totalRecords: e[0].TotalRows
          });
        }
      }
    } else {
      if (this.state.totalRecords !== 0)
        this.setState({
          totalRecords: 0,
          first: 0
        });
    }

    if (prevProps.MaxFromNo !== this.props.MaxFromNo) {
      this.setState({
        FromNo: this.props.MaxFromNo
      });
    }
    if (
      this.props.ReceivedPackingData !== prevProps.ReceivedPackingData &&
      this.props.ReceivedPackingData?.length > 0 &&
      !this.state.selectedWarehouse
    ) {
      const warehouseNames = this.getWarehouseNames();
      if (warehouseNames.length > 0) {
        this.setState({ selectedWarehouse: warehouseNames[0] });
      }
    }
  }

  getWarehouseNames = () => {
    const names = this.props.ReceivedPackingData?.map(
      (item) => item.WareHouseName
    );
    return [...new Set(names)];
  };

  getFilteredData = () => {
    const { selectedWarehouse } = this.state;
    return this.props.ReceivedPackingData?.filter(
      (item) => item.WareHouseName === selectedWarehouse
    );
  };

  handleWarehouseChange = (e) => {
    this.setState({ selectedWarehouse: e.target.value });
  };

  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows, first: event.first });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    //this.tblResponse.SortColumn = event.sortField;
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
  }

  searchFilter(e) {
    this.props.loadingData(true);
    this.tblResponse.SearchValue = e.target.value;
    this.props.fetchApi(this.tblResponse);
    this.props.fetchMappingApi(this.tblResponse);
  }

  //to sort
  onSort(event) {
    this.props.loadingData(true);
    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField =
      event.multiSortMeta[0].field === "CreatedDate"
        ? "CreatedDate"
        : event.multiSortMeta[0].field;
    this.tblResponse.SortColumn = sortField ? sortField : "";
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC"; //this.state.sortOrder === 1 ? 'DESC' : 'ASC';
    this.props.fetchMappingApi(this.tblResponse);
    this.props.fetchApi(this.tblResponse);
  }

  getStatus(value) {
    if (value == 0) {
      return <span className="span-status pending">Pending</span>;
    } else if (value == 1) {
      return (
        <span className="span-status p-dispatch">Partially Dispatched</span>
      );
    } else if (value == 2) {
      return <span className="span-status dispatch">Dispatched</span>;
    }
  }

  onPage(event) {
    //imitate delay of a backend call
    this.getLazyLoadingValues(event);
    this.props.fetchMappingApi(this.tblResponse);
    this.props.fetchApi(this.tblResponse);
  }
  onDateChange = () => {
    const { fromDate, toDate } = this.state;
    const roleName = sessionStorage.getItem("UserRole");
    if (fromDate && toDate) {
      this.props.fetchDetailApi({
        fromDate: fromDate,
        toDate: toDate,
        roleName: roleName
      });
    }
  };

  setFilter = (filter) => {
    const today = new Date().toISOString().split("T")[0];
    let fromDate = "";
    let toDate = today;

    switch (filter) {
      case "today":
        fromDate = today;
        break;
      case "week":
        const todayDate = new Date();
        const dayOfWeek = todayDate.getDay();
        const diffToMonday = (dayOfWeek === 0 ? -6 : 1) - dayOfWeek;
        const monday = new Date(todayDate);
        monday.setDate(todayDate.getDate() + diffToMonday);
        fromDate = monday.toISOString().split("T")[0];
        break;
      case "month":
        fromDate = new Date();
        fromDate.setDate(1);
        fromDate = fromDate.toISOString().split("T")[0];
        break;
      case "year":
        const startOfYear = new Date(new Date().getFullYear(), 0, 2);
        fromDate = startOfYear.toISOString().split("T")[0];
        break;
      default:
        fromDate = "2020-01-01";
    }

    this.setState({ activeFilter: filter, fromDate, toDate }, () => {
      const roleName = sessionStorage.getItem("UserRole");
      if (this.state.fromDate && this.state.toDate) {
        this.props.fetchDetailApi({
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          roleName: roleName
        });
      }
    });
  };

  render() {
    const { selectedWarehouse } = this.state;
    const warehouseNames = this.getWarehouseNames();
    const filteredData = this.getFilteredData();
    const filterLabels = {
      today: "Today",
      week: "Week",
      month: "Month",
      year: "Year"
    };
     
    const statusData = {
      animationEnabled: true,
      theme: "light2",
      height: 320,
      axisY: {
        lineThickness: 0,
        tickLength: 0,
        labelFormatter: () => "",
        gridThickness: 0
      },
      toolTip: {
        shared: true
      },
      legend: {
        cursor: "pointer",
        itemclick: function (e) {
          if (
            typeof e.dataSeries.visible === "undefined" ||
            e.dataSeries.visible
          ) {
            e.dataSeries.visible = false;
          } else {
            e.dataSeries.visible = true;
          }
          e.chart.render();
        }
      },
      data: [
        {
          type: "line",
          name: "Genuine Count",
          showInLegend: true,
          dataPoints: this.props.VerificationStatuses?.map((item) => ({
            label: item.Month,
            y: item.GenuineCount
          }))
        },
        {
          type: "line",
          name: "Already Scanned Count",
          showInLegend: true,
          dataPoints: this.props.VerificationStatuses?.map((item) => ({
            label: item.Month,
            y: item.AlreadyScannedCount
          }))
        },       
        {
          type: "line",
          name: "Fake Scans Count",
          showInLegend: true,
          dataPoints: this.props.VerificationStatuses?.map((item) => ({
            label: item.Month,
            y: item.FakeProductCount
          }))
        }
      ]
    };
    const total = (data = [], key) => {
      return data.reduce((sum, item) => sum + (item[key] || 0), 0);
    };
    const scannedProductOptions = {
      theme: "light1",
      animationEnabled: true,
      animationDuration: 1200,
      exportEnabled: false,
      height: 275,
      data: [
        {
          type: "pie",
          showInLegend: true,
          legendText: "{label}",
          toolTipContent: "{label}: <strong>{y}%</strong>",
          indexLabel: "{y}%",
          indexLabelPlacement: "inside",
          dataPoints: this.props.ScannedCountData?.map((item) => ({
            label: item.ProductName,
            y: parseFloat(
              (
                (item.ScendCount /
                  total(this.props.ScannedCountData, "ScendCount")) *
                100
              ).toFixed(2)
            )
          }))
        }
      ]
    };
    const visitedProductOptions = {
      height: 225,
      theme: "light1",
      animationEnabled: true,
      animationDuration: 1200,
      exportEnabled: false,
      legend: {
        verticalAlign: "center",
        horizontalAlign: "right"
      },
      data: [
        {
          type: "doughnut",
          showInLegend: true,
          legendText: "{label}",
          toolTipContent: "{label}: <strong>{y}%</strong>",
          indexLabel: "{y}%",
          indexLabelPlacement: "outside",
          dataPoints: this.props.VisitedCountData?.map((item) => ({
            label: item.ProductName,
            y: parseFloat(
              (
                (item.RecentlyVisitedCount /
                  total(this.props.VisitedCountData, "RecentlyVisitedCount")) *
                100
              ).toFixed(2)
            )
          }))
        }
      ]
    };
  
    const ratedProductOptions = {
      animationEnabled: true,
      height: 275,
      data: [
        {
          type: "doughnut",
          showInLegend: true,
          legendText: "{label}",
          toolTipContent: "{label}: <strong >{y}%</strong>",
          indexLabel: "{y}%",
          indexLabelPlacement: "outside",
          dataPoints: this.props.ProductRatingCountData?.map((item) => ({
            label: item.ProductName,
            y: parseFloat(
              (
                (item.ProductRatingCount /
                  total(
                    this.props.ProductRatingCountData,
                    "ProductRatingCount"
                  )) *
                100
              ).toFixed(2)
            )
          }))
        }
      ]
    };
    const packingData = {
      theme: "light2",
      animationEnabled: true,
      animationDuration: 1200,
      showInLegend: true,
      legendText: "{label}",
      height: 200,
      axisY: {
        lineThickness: 0,
        tickLength: 0,
        labelFormatter: () => "",
        gridThickness: 0
      },
      data: [
        {
          type: "column",
          dataPoints: this.props.PackingData?.map((item) => ({
            label: item.Date,
            y: item.TotalQuantity,
            toolTipContent: `Total Quantity: <strong>${item.TotalQuantity}</strong> </br> Total Carton Count: <strong>${item.TotalCartonCount}</strong> `
          }))
        }
      ]
    };
    const stockData = {
      theme:"light2",
      animationEnabled: true,
      animationDuration: 1200,
      showInLegend: true,
      legendText: "{label}",
      height: 270,
      axisY: {
        lineThickness: 0,
        tickLength: 0,
        labelFormatter: () => "",
        gridThickness: 0,
        title: "Stock Received"
      },
      data: [
        {
          type: "area",
          dataPoints: filteredData?.map((item) => ({
            label: item.ReceivedDate,
            y: item.ReceivedCount
          }))
        }
      ]
    };

    const { fromDate, toDate, activeFilter } = this.state;
    const userType = sessionStorage.getItem("UserType");
    const roleId = sessionStorage.getItem("UserRole");

    return (
      <React.Fragment>
        {['9', '8','13', '11'].includes(roleId) ? (
          <div className="d-flex align-items-center h-100">
            <section id="venue">
              <div className="d-flex container-fluid">
                <div className="row slidere-bg animate-in-down">
                  <div className="p-0 col-md-12">
                    <div
                      className="carousel slide carousel-fade"
                      data-ride="carousel"
                      data-interval="2000"
                      id="carousel1"
                    >
                      <div className="carousel-inner" role="listbox">
                        {this.props?.dashboardImages?.map((img, index) => (
                          <div
                            key={index}
                            className={`carousel-item ${index === 0 ? "active" : ""
                              }`}
                          >
                            <img
                              className="d-block img-fluid w-100"
                              src={img.FilePath}
                              alt={""}
                            />
                          </div>
                        ))}
                      </div>
                      <ol className="carousel-indicators">
                        {this.props?.dashboardImages?.map((_, index) => (
                          <li
                            key={index}
                            data-target="#carousel1"
                            data-slide-to={index}
                            className={index === 0 ? "active" : ""}
                          ></li>
                        ))}
                      </ol>
                      <a
                        className="carousel-control-prev"
                        href="#carousel1"
                        role="button"
                        data-slide="prev"
                      >
                        {" "}
                        <span
                          className="carousel-control-prev-icon"
                          aria-hidden="true"
                        />
                        <span className="sr-only">Previous</span>{" "}
                      </a>{" "}
                      <a
                        className="carousel-control-next"
                        href="#carousel1"
                        role="button"
                        data-slide="next"
                      >
                        {" "}
                        <span
                          className="carousel-control-next-icon"
                          aria-hidden="true"
                        />{" "}
                        <span className="sr-only">Next</span>{" "}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        ) : (
          <div className="m-top mb-5 mx-2">
            {this.props.loading && (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  height: "100%",
                  width: "100%",
                  backgroundColor: "rgba(255, 255, 255, 0.7)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 9999
                }}
              >
                <ThreeDot color="#7ec8e3" size="medium" text="" textColor="" />
              </div>
            )}
            <div class="d-flex justify-content-between form-group flex-wrap align-items-center">
              <div className="d-flex">
                <div class="input-group d-flex align-items-center">
                  <label htmlFor="fromDate" className="form-label fw-500">
                    From:
                  </label>
                  <input
                    type="date"
                    class="form-control date-input"
                    value={fromDate}
                    max={toDate}
                    onChange={(e) =>
                      this.setState(
                        { fromDate: e.target.value },
                        this.onDateChange
                      )
                    }
                  />
                </div>
                <div class="input-group d-flex align-items-center">
                  <label
                    htmlFor="toDate"
                    className="form-label ml-4 mr-1 fw-500"
                  >
                    To:
                  </label>
                  <input
                    type="date"
                    class="form-control date-input"
                    value={toDate}
                    min={fromDate}
                    onChange={(e) =>
                      this.setState(
                        { toDate: e.target.value },
                        this.onDateChange
                      )
                    }
                  />
                </div>
              </div>
              <div className="d-flex align-items-center mt-2 mt-md-0">
                {Object.keys(filterLabels).map((filter) => (
                  <button
                    key={filter}
                    className={`btn btn-filter d-flex align-items-center ${activeFilter === filter ? "active-btn" : ""
                      }`}
                    onClick={() => this.setFilter(filter)}
                  >
                    <i className="fa fa-calendar-alt"></i>{" "}
                    {filterLabels[filter]}
                  </button>
                ))}
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <Restricted
                  userType={userType}
                  roleId={roleId}
                  allowedRoleId={[1, 2]}
                  allowedUserType={1}
                >
                  <div className="row">
                    <div
                      className="col-6 col-sm-4 service-card mx-0"
                      onClick={() =>
                        (window.location = "/activation/issue-number")
                      }
                    >
                      <div className="panel panel-info">
                        <div className="panel-heading mt-2 ">
                          Numbers Issued
                        </div>
                        <div className="panel-body">
                          <div className="rotate">
                            <i className="fa fa-list-ol fa-4x"></i>
                          </div>
                          <h2>
                            {" "}
                            {this.props.UsersDeviceWiseData?.TotalIssue
                              ? this.props.UsersDeviceWiseData?.TotalIssue
                              : 0}
                          </h2>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-6 col-sm-4 service-card mx-0"
                      onClick={() => (window.location = "/masters/user-master")}
                    >
                      <div className="panel panel-info">
                        <MTooltip
                          placement="right"
                          title={
                            <React.Fragment>
                              <Typography className="circle">
                                Mobile users:{" "}
                                {this.props.UsersDeviceWiseData?.MobileUser
                                  ? this.props.UsersDeviceWiseData?.MobileUser
                                  : 0}
                              </Typography>
                              <Typography className="circle">
                                Tab users:{" "}
                                {this.props.UsersDeviceWiseData?.TabUser
                                  ? this.props.UsersDeviceWiseData?.TabUser
                                  : 0}
                              </Typography>
                              <Typography className="circle">
                                Web users:{" "}
                                {this.props.UsersDeviceWiseData?.WebUser
                                  ? this.props.UsersDeviceWiseData?.WebUser
                                  : 0}
                              </Typography>
                            </React.Fragment>
                          }
                          arrow
                        >
                          <div className="panel-heading mt-2">Total Users</div>
                          <div className="panel-body">
                            <div className="rotate">
                              <i className="fa fa-users fa-4x"></i>
                            </div>
                            <h2>
                              {this.props.UsersDeviceWiseData?.TotalUser
                                ? this.props.UsersDeviceWiseData?.TotalUser
                                : 0}
                            </h2>
                          </div>
                        </MTooltip>
                      </div>
                    </div>
                    <div
                      className="col-6 col-sm-4 service-card mx-0"
                      onClick={() =>
                        (window.location = "/masters/product-master")
                      }
                    >
                      <div className="panel panel-info">
                        <div className="panel-heading mt-2">Total Products</div>
                        <div className="panel-body">
                          <div className="panel-body">
                            <div className="rotate">
                              <i className="fa fa-tag fa-4x"></i>
                            </div>
                            <h2>
                              {this.props.UsersDeviceWiseData?.TotalProduct
                                ? this.props.UsersDeviceWiseData?.TotalProduct
                                : 0}
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Restricted>
                <div className="row mt-3">
                  <Restricted
                    userType={userType}
                    roleId={roleId}
                    allowedRoleId={[1, 2]}
                    allowedUserType={1}
                  >
                    <div className="col-md-6">
                      <div class="card-header dashchart px-0">
                        Top Scanned Products
                      </div>
                      <div
                        hidden={!this.props.ScannedCountData}
                        className="pie-chart"
                      >
                        <Paper className="rounded-0 py-2">
                          {this.props.ScannedCountData?.length > 0 ? (
                            <CanvasJSChart options={scannedProductOptions} />
                          ) : (
                            <div className="p-3">No data available</div>
                          )}
                        </Paper>
                      </div>
                    </div>
                  </Restricted>
                  <Restricted
                    userType={userType}
                    roleId={roleId}
                    allowedRoleId={[1, 2]}
                    allowedUserType={1}
                  >
                    <div className="col-md-6">
                      <div class="card-header dashchart">
                        Top Rated Products
                      </div>
                      <div
                        hidden={!this.props.ProductRatingCountData}
                        className=" pie-chart"
                      >
                        <Paper className="rounded-0 py-2">
                          {this.props.ProductRatingCountData?.length > 0 ? (
                            <CanvasJSChart options={ratedProductOptions} />
                          ) : (
                            <div className="p-3">No data available</div>
                          )}
                        </Paper>
                      </div>
                    </div>
                  </Restricted>
                </div>
                <div className="row mt-3">
                  {" "}
                  <Restricted
                    userType={userType}
                    roleId={roleId}
                    allowedRoleId={[1, 2, 3]}
                    allowedUserType={1}
                  >
                    <div className="col-md-12">
                      <div className="cards p-0 pie-chart">
                        <div class="card-header dashchart">
                          Primary Packing & Carton Packing
                        </div>
                        <Paper className="rounded-0">
                          {this.props.PackingData?.length > 0 ? (
                            <CanvasJSChart options={packingData} />
                          ) : (
                            <div className="p-3">No data available</div>
                          )}{" "}
                        </Paper>
                      </div>
                    </div>
                  </Restricted>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <Restricted
                    userType={userType}
                    roleId={roleId}
                    allowedRoleId={[1, 2]}
                    allowedUserType={1}
                  >
                    <div className="col-md-12">
                      <div class="card-header dashchart">
                        Top Visited Products{" "}
                      </div>
                      <div
                        hidden={!this.props.VisitedCountData}
                        className=" pie-chart"
                      >
                        <Paper className="rounded-0 p-2">
                          {this.props.VisitedCountData?.length > 0 ? (
                            <CanvasJSChart options={visitedProductOptions} />
                          ) : (
                            <div className="p-3">No data available</div>
                          )}{" "}
                        </Paper>
                      </div>
                    </div>
                  </Restricted>
                </div>
                <div className="row mt-3">
                  {" "}
                  <Restricted
                    userType={userType}
                    roleId={roleId}
                    allowedRoleId={[1, 2]}
                    allowedUserType={1}
                  >
                    <div
                      className="col-md-12 service-card h-100"
                      onClick={() =>
                        (window.location = "/activation/warranty-approval")
                      }
                    >
                      <div className="panel panel-info">
                        <MTooltip
                          placement="top"
                          title={
                            <React.Fragment>
                              <Typography className="circle">
                                Claimed:{" "}
                                {this.props.WarrantyCountDetailData?.IsClaim
                                  ? this.props.WarrantyCountDetailData?.IsClaim
                                  : 0}
                              </Typography>
                              <Typography className="circle">
                                Pending:{" "}
                                {this.props.WarrantyCountDetailData?.Pending
                                  ? this.props.WarrantyCountDetailData?.Pending
                                  : 0}
                              </Typography>
                              <Typography className="circle">
                                Approved:{" "}
                                {this.props.WarrantyCountDetailData?.IsApprove
                                  ? this.props.WarrantyCountDetailData
                                    ?.IsApprove
                                  : 0}
                              </Typography>
                              <Typography className="circle">
                                Rejected:{" "}
                                {this.props.WarrantyCountDetailData?.IsReject
                                  ? this.props.WarrantyCountDetailData?.IsReject
                                  : 0}
                              </Typography>
                            </React.Fragment>
                          }
                          arrow
                        >
                          <div className="d-flex panel-heading mt-2 justify-content-center align-items-center panel-info">
                            <i className="fa 	fa-shield-alt fa-4x mx-2"></i>{" "}
                            Warranty Registrations:{" "}
                            <span className="mx-2 text-18 fw-500">
                              {this.props.WarrantyCountDetailData?.TotalWarranty
                                ? this.props.WarrantyCountDetailData
                                  ?.TotalWarranty
                                : 0}
                            </span>
                          </div>
                        </MTooltip>
                      </div>
                    </div>
                  </Restricted>
                </div>
                <div className="row mt-3">
                  {" "}
                  <Restricted
                    userType={userType}
                    roleId={roleId}
                    allowedRoleId={[1, 2]}
                    allowedUserType={3}
                  >
                    <div className={`${userType == 3 ? "vw-100" : "col-md-6"}`}>
                      <div className="cards p-0 pie-chart">
                        <div class="card-header dashchart">Stock Receiving</div>
                        <Paper className="rounded-0">
                          {this.props.ReceivedPackingData?.length > 0 && (
                            <div className="d-flex flex-column justify-content-end p-2 align-items-end">
                              <div className="mr-2 font-weight-normal text-12">
                                Select Warehouse:
                              </div>
                              <select
                                className="rounded-sm text-12"
                                value={selectedWarehouse}
                                onChange={this.handleWarehouseChange}
                              >
                                {warehouseNames.map((name, index) => (
                                  <option key={index} value={name}>
                                    {name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}
                          {selectedWarehouse &&
                            (this.props.ReceivedPackingData?.length > 0 ? (
                              <CanvasJSChart options={stockData} />
                            ) : (
                              <div className="p-3">No data available</div>
                            ))}
                        </Paper>
                      </div>
                    </div>
                  </Restricted>
                  <Restricted
                    userType={userType}
                    roleId={roleId}
                    allowedRoleId={[1, 2]}
                    allowedUserType={1}
                  >
                    <div className="col-md-6">
                      <div className="cards p-0 pie-chart">
                        <div class="card-header dashchart">
                          Verification Status
                        </div>
                        <Paper className="rounded-0">
                          {this.props.VerificationStatuses?.length > 0 ? (
                            <CanvasJSChart options={statusData} />
                          ) : (
                            <div className="p-3">No data available</div>
                          )}{" "}
                        </Paper>
                      </div>
                    </div>
                  </Restricted>
                </div>
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    DashboardList: state.dashboard?.items?.DashboardListData,
    TotalMapping: state.dashboard?.items?.DashboardCount?.TotalMapping,
    TotalDeMapping: state.dashboard?.items?.DashboardCount?.TotalDeMapping,
    TotalDamage: state.dashboard?.items?.DashboardCount?.TotalDamage,
    TotalScans: state.dashboard?.items?.DashboardCount?.TotalScans,
    TotalIssue: state.dashboard?.items?.DashboardCount?.TotalIssue,
    DeMappingChart: state.dashboard?.items?.DeMappingList,
    MappingChart: state.dashboard?.items?.MappingList,
    Months: state.dashboard?.items?.MonthName,
    MappingData: state.mapping.items,
    OrderChart: state.dashboard?.items?.OrderCharts,
    ProductData: state.dashboard?.items?.ProductData,
    OrderDataList: state.dashboard?.items?.OrderDataList,
    UsersDeviceWiseData: state.dashboardDetail?.items?.UsersDeviceWiseData,
    WarrantyCountDetailData:
      state.dashboardDetail?.items?.WarrantyCountDetailData,
    ProductRatingCountData:
      state.dashboardDetail?.items?.ProductRatingCountData,
    ScannedCountData: state.dashboardDetail?.items?.ScannedCountData,
    VisitedCountData: state.dashboardDetail?.items?.VisitedCountData,
    PackingData: state.dashboardDetail?.items?.PackingData,
    VerificationStatuses: state.dashboardDetail?.items?.VerificationStatuses,
    ReceivedPackingData: state.dashboardDetail?.items?.ReceivedPackingData,
    dashboardImages: state.dashboardImage?.items,
    loading: state.dashboardDetail?.loading
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    fetchApi: (obj) => {
      dispatch(dashboardActions.fetchData(obj));
    },
    fetchDetailApi: (obj) => {
      dispatch(dashboardDetailActions.fetchDashboardData(obj));
    },
    fetchImageApi: () => {
      dispatch(dashboardImageActions.fetchDashboardImage());
    },
    loadingDetailData: (isLoding) =>
      dispatch(dashboardDetailActions.loadingData(isLoding)),
    loadingData: (isLoding) => dispatch(dashboardActions.loadingData(isLoding)),
    fetchMappingApi: (obj) => {
      dispatch(mappingActions.getAll(obj));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
